export const navigationItems = [
  {
    id: "schedules",
    icon: "mdi-calendar-month",
    text: "My Schedules",
    to: { name: "Schedules" },
  },
  {
    id: "clock",
    icon: "mdi-clock",
    text: "Clock In/Out",
    to: { name: "TimeScan" },
  },
  {
    id: "timesheets",
    icon: "mdi-timetable",
    text: "My Timesheets",
    to: { name: "Timesheet" },
  },
  {
    id: "studentAttendance",
    icon: "mdi-account-check",
    text: "Student Attendance",
    to: { name: "Attendance" },
  },
];
